export const TRANSPORTATION_MODES = {
  oceanFcl: "oceanFcl",
  oceanLcl: "oceanLcl",
  rail: "rail",
  truck: "truck",
  air: "air",
} as const;

export const WEIGHT_UNITS = {
  teus: "teus",
  lb: "lb",
  kg: "kg",
} as const;

export const TRANSPORTATION_MODE_OPTIONS = [
  {label: "Ocean FCL", value: TRANSPORTATION_MODES.oceanFcl},
  {label: "Ocean LCL", value: TRANSPORTATION_MODES.oceanLcl},
  {label: "Rail", value: TRANSPORTATION_MODES.rail},
  {label: "Truck", value: TRANSPORTATION_MODES.truck},
  {label: "Air", value: TRANSPORTATION_MODES.air},
];

export const OCEAN_WEIGHT_UNIT_OPTIONS = [
  {label: "TEUs", value: WEIGHT_UNITS.teus},
  {label: "LB", value: WEIGHT_UNITS.lb},
  {label: "KG", value: WEIGHT_UNITS.kg},
];

export const WEIGHT_UNIT_OPTIONS = [
  {label: "LB", value: WEIGHT_UNITS.lb},
  {label: "KG", value: WEIGHT_UNITS.kg},
];

export const REEFER_OPTIONS = [
  {label: "Yes", value: "true"},
  {label: "No", value: "false"},
];

export const IS_INLAND_OPTIONS = [
  {label: "Yes", value: "true"},
  {label: "No", value: "false"},
];
